module.exports = __webpack_public_path__ + "static/media/retread-dealer.8df31d52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dealerFeatures/retread-dealer.svg
// module id = 2544
// module chunks = 2